export default {
  CASES: "cases",
  CASE: "case",
  CASES_DEFAULT: "cases_default",
  VALUE: "value",
  FILTER: "filter"
}
